<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form v-if="radio === 1" ref="form" :model="model" @keydown.native.enter.prevent="onSaveBtnClick">
      <el-form-item label="因子名称" prop="factorId">
        <el-select
          v-model="model.factorId"
          :disabled="operator !== 1"
          style="width:100%;"
        >
          <el-option
            v-for="factor in factors"
            :key="factor.id"
            :value="factor.id"
            :label="factor.displayName"
          />
        </el-select>
      </el-form-item>

      <el-row :gutter="gutter">
        <el-col :span="8">
          <el-form-item
            :label="`修正下限${currentFactor.stdUnit ? `(单位: ${currentFactor.stdUnit})` : ''}`"
            prop="amendLowRange"
            :rules="{
              validator: amendLowRangeValidator
            }"
          >
            <el-input v-model.trim="model.amendLowRange" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`修正上限${currentFactor.stdUnit ? `(单位: ${currentFactor.stdUnit})` : ''}`"
            prop="amendHighRange"
            :rules="{
              validator: amendHighRangeValidator
            }"
          >
            <el-input v-model.trim="model.amendHighRange" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`修正值${currentFactor.stdUnit ? `(单位: ${currentFactor.stdUnit})` : ''}`"
            prop="amendValue"
            :rules="{
              validator: amendValueValidator
            }"
          >
            <el-input v-model.trim="model.amendValue" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="gutter">
        <el-col :span="12">
          <el-form-item
            :label="`超标下限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="limitLow"
          >
            <el-input v-model.trim="model.limitLow" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="`超标上限${model.stdUnit ? `(单位: ${model.stdUnit})` : ''}`"
            prop="limitHigh"
            :rules="{
              validator: limitHighValidator
            }"
          >
            <el-input v-model.trim="model.limitHigh" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="是否报警" prop="factorId">
        <el-switch v-model="model.isAlarm" />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="`报警下限${currentFactor.stdUnit ? `(单位: ${currentFactor.stdUnit})` : ''}`"
            prop="alarmMin"
            :rules="{
              validator: alarmMinValidator
            }"
          >
            <el-input v-model="model.alarmMin" :disabled="!model.isAlarm" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="`报警上限${currentFactor.stdUnit ? `(单位: ${currentFactor.stdUnit})` : ''}`"
            prop="alarmMax"
            :rules="{
              validator: alarmMaxValidator
            }"
          >
            <el-input v-model="model.alarmMax" :disabled="!model.isAlarm" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="是否启用" prop="status">
        <el-switch v-model="model.status" />
      </el-form-item>
    </el-form>

    <el-form v-else ref="form" :model="model" @keydown.native.enter.prevent="onSaveBtnClick">
      <el-form-item label="状态名称" prop="statusName">
        <el-input v-model.trim="model.statusName" readonly />
      </el-form-item>

      <el-form-item label="是否报警" prop="factorId">
        <el-switch v-model="model.isAlarm" />
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="`报警下限${deviceStatusMap[model.deviceStatusId] ? `(单位: ${deviceStatusMap[model.deviceStatusId].unit ? deviceStatusMap[model.deviceStatusId].unit : '无'})` : ''}`"
            prop="alarmMin"
            :rules="{
              validator: alarmValidator
            }"
          >
            <el-input v-model="model.alarmMin" :disabled="!model.isAlarm" type="number" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="`报警上限${deviceStatusMap[model.deviceStatusId] ? `(单位: ${deviceStatusMap[model.deviceStatusId].unit ? deviceStatusMap[model.deviceStatusId].unit : '无'})` : ''}`"
            prop="alarmMax"
            :rules="{
              validator: alarmValidator
            }"
          >
            <el-input v-model="model.alarmMax" :disabled="!model.isAlarm" type="number" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="关键参数" prop="isImportance">
        <el-switch v-model="model.isImportance" />
      </el-form-item>

      <el-form-item label="是否启用" prop="status">
        <el-switch v-model="model.status" />
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'

export default {
  name: 'SiteDeviceFactorEditor',
  extends: BaseEditor,
  props: {
    siteDevice: {
      required: true
    },
    radio: {
      required: true
    },
    deviceStatusMap: {
      type: Object
    }
  },
  computed: {
    apiKey () {
      return this.radio === 1 ? 'SiteDeviceFactor' : 'SiteDeviceStatus'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return this.radio === 1 ? '站房仪器因子' : '站房仪器状态'
    },
    currentFactor () {
      return this.factorMap[this.model.factorId] || {}
    }
  },
  methods: {
    initModel () {
      let {siteDevice} = this

      return siteDevice ? {
        siteId: siteDevice.siteId,
        siteDeviceId: siteDevice.id,
        isAlarm: false,
        status: true
      } : {}
    },
    amendLowRangeValidator (rule, value, callback) {
      let {amendHighRange} = this.model

      if (value === null || value === undefined || value === '') {
        if (amendHighRange === null || amendHighRange === undefined || amendHighRange === '') {
          return callback()
        }

        return callback(new Error('请输入修正下限值'))
      }

      return callback()
    },
    amendHighRangeValidator (rule, value, callback) {
      let {amendLowRange} = this.model

      if (value === null || value === undefined || value === '') {
        if (amendLowRange === null || amendLowRange === undefined || amendLowRange === '') {
          return callback()
        }

        return callback(new Error('请输入修正上限值'))
      } else {
        if (Number(value) < Number(amendLowRange)) {
          return callback(new Error('修正上限值必须大于修正下限值'))
        }
      }

      return callback()
    },
    amendValueValidator (rule, value, callback) {
      let {amendLowRange, amendHighRange} = this.model

      if (value === null || value === undefined || value === '') {
        if ((amendLowRange === null || amendLowRange === undefined || amendLowRange === '') && (amendHighRange === null || amendHighRange === undefined || amendHighRange === '')) {
          return callback()
        } else {
          return callback(new Error('请输入修正值'))
        }
      }

      value = Number(value)

      if (Number(amendLowRange) <= value && Number(amendHighRange) >= value) {
        return callback(new Error('请修正值不能在修正上下限范围内'))
      }

      return callback()
    },
    limitHighValidator (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        return callback()
      }

      let {limitLow} = this.model

      if (limitLow === null || limitLow === undefined || limitLow === '') {
        return callback()
      }

      if (value > limitLow) {
        return callback()
      }

      return callback(new Error('超标上限值必须大于超标下限值'))
    },
    alarmValidator (rule, value, callback) {
      let {isAlarm, alarmMax, alarmMin} = this.model
      let alarmMaxIsEmpty = alarmMax === null || alarmMax === undefined || alarmMax === ''
      let alarmMinIsEmpty = alarmMin === null || alarmMin === undefined || alarmMin === ''

      if (isAlarm) {
        if (alarmMaxIsEmpty && alarmMinIsEmpty) {
          return callback(new Error('请填写报警上下限'))
        } else if (alarmMax && alarmMin && Number(alarmMin) >= Number(alarmMax)) {
          return callback(new Error('报警下限必须小于报警上限'))
        }
      }

      callback()
    },
    alarmMinValidator (rule, value, callback) {
      let {isAlarm, alarmMax} = this.model
      let valueIsEmpty = value === null || value === undefined || value === ''
      let alarmMaxIsEmpty = alarmMax === null || alarmMax === undefined || alarmMax === ''

      if ((isAlarm || !alarmMaxIsEmpty)) {
        if (valueIsEmpty) {
          return callback(new Error('请填写报警下限'))
        } else if (Number(value) >= Number(alarmMax)) {
          return callback(new Error('报警下限必须小于报警上限'))
        }
      }

      callback()
    },
    alarmMaxValidator (rule, value, callback) {
      let {isAlarm, alarmMin} = this.model
      let alarmMinIsEmpty = alarmMin === null || alarmMin === undefined || alarmMin === ''
      let valueIsEmpty = value === null || value === undefined || value === ''

      if (isAlarm || !alarmMinIsEmpty) {
        if (valueIsEmpty) {
          return callback(new Error('请填写报警上限'))
        } else {
          if (Number(value) <= Number(alarmMin)) {
            return callback(new Error('报警上限必须大于报警下限'))
          }
        }
      }

      callback()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/SiteDeviceFactorEditor.vue